/* src/app/shared/invoice/remits/css.scss */
.underline {
  text-decoration: underline;
}
/*# sourceMappingURL=css.css.map */
